module.exports = __webpack_public_path__ + "img/symbol-glasses-signature-ko.0d4b83ee.svg";